import { info, normalText } from 'assets/colors/colors';

interface INoDataSvg {
  readonly title: string;
  readonly subTitle: string;
}

interface IImportExportProps {
  readonly fill?: string;
  readonly width?: string;
  readonly height?: string;
}

function NoDataSvg({ title, subTitle }: INoDataSvg) {
  return (
    <>
      <svg
        width="167"
        height="168"
        viewBox="0 0 167 168"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M83.5 168C129.616 168 167 130.392 167 84C167 37.6081 129.616 0 83.5 0C37.3842 0 0 37.6081 0 84C0 130.392 37.3842 168 83.5 168Z"
          fill="#F2F2F2"
        />
        <path
          d="M137.979 52.4642L121.383 114.36C121.246 114.892 121.005 115.391 120.672 115.829C120.34 116.266 119.923 116.633 119.448 116.908C118.972 117.183 118.446 117.36 117.901 117.428C117.355 117.497 116.802 117.457 116.273 117.309L64.8544 103.523C64.3199 103.419 63.813 103.205 63.3664 102.893C62.9198 102.582 62.5434 102.18 62.2614 101.715C61.9793 101.249 61.7979 100.729 61.7289 100.189C61.6598 99.649 61.7045 99.1005 61.8603 98.5787L78.5 36.5171C78.637 35.9849 78.8788 35.4855 79.2112 35.0479C79.5436 34.6104 79.9599 34.2435 80.4358 33.9689C80.9117 33.6942 81.4377 33.5172 81.9828 33.4483C82.528 33.3794 83.0814 33.4199 83.6107 33.5675L135.029 47.3535C136.088 47.6552 136.989 48.3573 137.539 49.3113C138.09 50.2653 138.247 51.3961 137.979 52.4642Z"
          fill="#D3D9DD"
        />
        <path
          d="M128.468 52.5035L86.7152 41.309C85.6482 41.0229 84.5513 41.656 84.2652 42.723L70.0888 95.597C69.8028 96.664 70.4358 97.7609 71.5028 98.047L113.255 109.242C114.322 109.528 115.419 108.895 115.705 107.828L129.882 54.9535C130.168 53.8865 129.535 52.7896 128.468 52.5035Z"
          fill="white"
        />
        <path
          d="M119.625 53.2419L122.003 44.376C122.09 44.0796 122.116 43.7686 122.079 43.4618C122.043 43.155 121.944 42.8588 121.79 42.5913C121.636 42.3237 121.428 42.0902 121.181 41.9051C120.934 41.72 120.651 41.5871 120.351 41.5144L115.193 40.1313C115.566 38.6785 115.355 37.1373 114.605 35.8381C113.855 34.539 112.626 33.5854 111.182 33.1819C109.744 32.8199 108.221 33.0435 106.948 33.8037C105.676 34.5639 104.757 35.7985 104.394 37.236L99.2352 35.8529C98.9388 35.7656 98.6278 35.7395 98.321 35.776C98.0142 35.8125 97.7181 35.911 97.4505 36.0654C97.1829 36.2199 96.9495 36.4271 96.7643 36.6744C96.5792 36.9218 96.4463 37.2042 96.3736 37.5044L93.9967 46.3694L119.625 53.2419ZM110.392 36.7713C110.774 36.8738 111.118 37.0872 111.378 37.3847C111.639 37.6822 111.806 38.0503 111.857 38.4426C111.909 38.8348 111.843 39.2335 111.668 39.5883C111.493 39.9431 111.217 40.238 110.874 40.4357C110.531 40.6335 110.138 40.7252 109.743 40.6993C109.348 40.6733 108.97 40.5309 108.656 40.29C108.343 40.0492 108.107 39.7206 107.98 39.346C107.853 38.9714 107.84 38.5674 107.942 38.1853C108.001 37.9264 108.113 37.6824 108.271 37.4687C108.428 37.255 108.629 37.0761 108.859 36.9434C109.089 36.8106 109.344 36.7268 109.607 36.6972C109.871 36.6676 110.139 36.6928 110.392 36.7713Z"
          fill="#BEC6CB"
        />
        <path
          opacity="0.7"
          d="M101.093 86.8609L99.8637 91.4475C99.7661 91.7924 99.5379 92.0856 99.2274 92.2648C98.9169 92.444 98.5488 92.495 98.2014 92.4069L92.9599 91.0016C92.7874 90.9576 92.6259 90.8786 92.4852 90.7697C92.3445 90.6607 92.2276 90.524 92.1419 90.3681C92.0498 90.2158 91.9898 90.0463 91.9659 89.8699C91.9419 89.6936 91.9544 89.5142 92.0026 89.3429L93.2331 84.7534C93.2771 84.581 93.356 84.4194 93.465 84.2787C93.5739 84.138 93.7106 84.0212 93.8666 83.9355C94.0188 83.8433 94.1884 83.7834 94.3647 83.7595C94.5411 83.7355 94.7204 83.748 94.8917 83.7962L100.134 85.2018C100.479 85.2993 100.772 85.5276 100.952 85.8381C101.131 86.1485 101.182 86.5166 101.094 86.8641L101.093 86.8609ZM107.506 65.3998L102.716 80.9737C102.664 81.1457 102.578 81.3057 102.464 81.4446C102.349 81.5834 102.209 81.6984 102.05 81.7828C101.896 81.8738 101.724 81.9328 101.547 81.9563C101.369 81.9798 101.188 81.9673 101.015 81.9195L95.7718 80.5137C95.5983 80.4686 95.4356 80.389 95.2934 80.2798C95.1512 80.1705 95.0325 80.0337 94.9442 79.8776C94.7519 79.5697 94.6896 79.1981 94.7708 78.8444L98.4131 62.9618C98.4499 62.7889 98.5231 62.6257 98.6277 62.4831C98.7324 62.3405 98.8661 62.2217 99.02 62.1347C99.17 62.0417 99.3376 61.9811 99.5123 61.9566C99.687 61.9321 99.8649 61.9444 100.035 61.9925L106.589 63.7498C106.76 63.793 106.92 63.8714 107.06 63.98C107.199 64.0887 107.314 64.2251 107.397 64.3807C107.486 64.5332 107.542 64.7029 107.561 64.8786C107.58 65.0543 107.561 65.2319 107.506 65.3998Z"
          fill="#D3D9DD"
        />
        <path
          opacity="0.38"
          d="M90.0362 52.6493L111.951 112.859C112.144 113.374 112.232 113.921 112.211 114.47C112.19 115.019 112.059 115.559 111.827 116.057C111.595 116.554 111.266 117.001 110.859 117.37C110.452 117.739 109.975 118.024 109.457 118.206L59.4394 136.412C58.9421 136.633 58.4039 136.748 57.8595 136.749C57.315 136.75 56.7764 136.637 56.2782 136.418C55.7801 136.198 55.3334 135.877 54.967 135.474C54.6007 135.071 54.3226 134.596 54.1509 134.08L32.1774 73.7081C31.9844 73.1938 31.8959 72.646 31.9171 72.097C31.9383 71.548 32.0689 71.0087 32.3011 70.5108C32.5333 70.0128 32.8625 69.5662 33.2694 69.197C33.6763 68.8279 34.1528 68.5436 34.6709 68.3608L84.6889 50.1558C85.7295 49.7952 86.8696 49.8538 87.8677 50.3192C88.8658 50.7846 89.6436 51.6203 90.0362 52.6493Z"
          fill="#D3D9DD"
        />
        <path
          d="M87.376 57.9716L109.291 118.181C109.484 118.696 109.572 119.244 109.551 119.793C109.53 120.342 109.399 120.881 109.167 121.379C108.935 121.877 108.606 122.323 108.199 122.693C107.792 123.062 107.315 123.346 106.797 123.529L56.7792 141.734C56.2819 141.955 55.7437 142.07 55.1993 142.072C54.6549 142.073 54.1162 141.96 53.6181 141.74C53.1199 141.52 52.6733 141.199 52.3069 140.796C51.9405 140.393 51.6625 139.919 51.4907 139.402L29.5173 79.0304C29.3242 78.516 29.2357 77.9683 29.257 77.4193C29.2782 76.8703 29.4087 76.331 29.6409 75.833C29.8731 75.3351 30.2023 74.8885 30.6092 74.5193C31.0162 74.1501 31.4926 73.8659 32.0108 73.6831L82.0287 55.4781C83.0693 55.1174 84.2094 55.176 85.2076 55.6415C86.2057 56.1069 86.9834 56.9426 87.376 57.9716Z"
          fill="#D3D9DD"
        />
        <path
          d="M79.61 63.4599L38.9946 78.2427C37.9567 78.6205 37.4215 79.7682 37.7993 80.8061L56.5197 132.24C56.8975 133.278 58.0452 133.813 59.0832 133.436L99.6986 118.653C100.737 118.275 101.272 117.127 100.894 116.089L82.1734 64.6553C81.7957 63.6173 80.648 63.0821 79.61 63.4599Z"
          fill="white"
        />
        <path
          d="M72.7953 69.1377L69.6562 60.5132C69.5577 60.2204 69.4007 59.9507 69.1948 59.7204C68.9889 59.4901 68.7383 59.304 68.4584 59.1735C68.1784 59.0429 67.8748 58.9706 67.566 58.9609C67.2573 58.9512 66.9498 59.0043 66.6621 59.117L61.6442 60.9434C61.1166 59.5394 60.0598 58.3981 58.7005 57.7643C57.3412 57.1305 55.7876 57.0545 54.373 57.5528C52.9879 58.081 51.8692 59.1376 51.2628 60.4904C50.6564 61.8432 50.612 63.3813 51.1394 64.7668L46.1214 66.5932C45.8286 66.6917 45.5589 66.8487 45.3286 67.0546C45.0983 67.2605 44.9123 67.5111 44.7817 67.7911C44.6511 68.071 44.5788 68.3746 44.5691 68.6834C44.5594 68.9921 44.6125 69.2997 44.7252 69.5873L47.8639 78.2108L72.7953 69.1377ZM55.7855 60.9453C56.1572 60.81 56.5607 60.788 56.9449 60.882C57.3291 60.976 57.6769 61.1818 57.9441 61.4735C58.2113 61.7651 58.3861 62.1295 58.4463 62.5204C58.5064 62.9114 58.4493 63.3114 58.2822 63.6699C58.115 64.0284 57.8453 64.3293 57.5071 64.5345C57.1689 64.7397 56.7775 64.84 56.3823 64.8228C55.9871 64.8055 55.6059 64.6714 55.2869 64.4375C54.9679 64.2036 54.7254 63.8804 54.5902 63.5087C54.4899 63.2628 54.4415 62.9988 54.4481 62.7334C54.4546 62.4679 54.5159 62.2067 54.6281 61.966C54.7403 61.7253 54.9011 61.5104 55.1002 61.3348C55.2994 61.1591 55.5327 61.0265 55.7855 60.9453Z"
          fill="#BEC6CB"
        />
        <path
          opacity="0.7"
          d="M76.9031 107.306L78.527 111.767C78.645 112.106 78.6262 112.477 78.4748 112.802C78.3233 113.127 78.0511 113.38 77.716 113.507L72.6172 115.363C72.4508 115.425 72.2732 115.454 72.0954 115.445C71.9177 115.436 71.7436 115.392 71.5839 115.313C71.4211 115.241 71.2748 115.137 71.154 115.006C71.0333 114.875 70.9406 114.721 70.8818 114.553L69.2568 110.089C69.1939 109.922 69.1659 109.745 69.1744 109.567C69.183 109.389 69.2279 109.215 69.3064 109.056C69.3782 108.893 69.4827 108.746 69.6134 108.626C69.7441 108.505 69.8981 108.412 70.0661 108.353L75.1658 106.497C75.5042 106.379 75.8753 106.398 76.2002 106.55C76.525 106.701 76.7779 106.973 76.9051 107.308L76.9031 107.306ZM69.8439 86.0514L74.8551 101.553C74.9109 101.724 74.9324 101.905 74.9184 102.084C74.9044 102.263 74.8552 102.438 74.7736 102.598C74.6993 102.761 74.5929 102.908 74.4608 103.029C74.3286 103.15 74.1735 103.244 74.0045 103.304L68.9039 105.16C68.7359 105.223 68.557 105.251 68.3779 105.243C68.1987 105.235 68.023 105.191 67.8612 105.114C67.5271 104.972 67.2629 104.704 67.1265 104.367L60.9986 89.2708C60.9296 89.108 60.8959 88.9324 60.8998 88.7556C60.9037 88.5788 60.9451 88.4049 61.0212 88.2453C61.0907 88.0831 61.1932 87.9373 61.3222 87.817C61.4512 87.6968 61.6039 87.6048 61.7705 87.5469L68.1464 85.2263C68.3113 85.1634 68.4876 85.1356 68.6639 85.1448C68.8402 85.1539 69.0126 85.1997 69.1702 85.2793C69.3308 85.3529 69.4739 85.4598 69.5901 85.5929C69.7062 85.7261 69.7928 85.8823 69.8439 86.0514Z"
          fill="#D3D9DD"
        />
      </svg>
      <p style={{ color: '#98A5B9', fontSize: '20px', marginBottom: '0' }}>
        {title}
      </p>
      <p style={{ color: '#98A5B9', fontSize: '12px' }}>{subTitle}</p>
    </>
  );
}

interface PinIconProps {
  readonly fill: string;
  readonly style?: React.CSSProperties;
}

function PinIcon({ fill, style }: PinIconProps) {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <path
        d="M14.1509 4.3662C14.717 4.92958 14.717 5.84507 14.1509 6.33803L12.1698 8.30986L6.65094 2.8169L8.63208 0.84507C9.19811 0.28169 10.1179 0.28169 10.6132 0.84507L11.8868 2.11268L14.0094 0L15 0.985915L12.8774 3.09859L14.1509 4.3662ZM10.0472 8.4507L9.0566 7.46479L7.07547 9.43662L5.58962 7.95775L7.57076 5.98592L6.58019 5L4.59906 6.97183L3.53774 5.98592L1.5566 7.95775C0.990566 8.52113 0.990566 9.43662 1.5566 9.92958L2.83019 11.1972L0 14.0141L0.990566 15L3.82075 12.1831L5.09434 13.4507C5.66038 14.0141 6.58019 14.0141 7.07547 13.4507L9.0566 11.4789L8.06604 10.493L10.0472 8.4507Z"
        fill={fill}
      />
    </svg>
  );
}

function PdfIcon({ fill, width = '18', height = '18' }: IImportExportProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.5 1.5H4.5C3.675 1.5 3 2.175 3 3V6.75H2.25C1.83579 6.75 1.5 7.08579 1.5 7.5V12.75C1.5 13.1642 1.83579 13.5 2.25 13.5H3V15C3 15.825 3.675 16.5 4.5 16.5H13.5C14.325 16.5 15 15.825 15 15V6L10.5 1.5ZM4.5 15V13.5H13.5V15H4.5ZM4.5 6.75H13.5V6H9.75V3H4.5V6.75ZM4.42747 10.6968H3.81072V12H3V8.25H4.42747C4.71594 8.25 4.96297 8.30409 5.16855 8.41226C5.37579 8.52043 5.53413 8.66896 5.64355 8.85783C5.75463 9.04499 5.81017 9.25962 5.81017 9.50172C5.81017 9.74382 5.75463 9.95416 5.64355 10.1327C5.53413 10.3113 5.37579 10.4504 5.16855 10.55C4.96297 10.6478 4.71594 10.6968 4.42747 10.6968ZM3.81072 10.0452H4.42747C4.56176 10.0452 4.66952 10.022 4.75076 9.97562C4.83366 9.92926 4.89417 9.86573 4.9323 9.78503C4.97209 9.70261 4.99199 9.60989 4.99199 9.50687C4.99199 9.40041 4.97209 9.30168 4.9323 9.21068C4.89417 9.11796 4.83366 9.04327 4.75076 8.98661C4.66952 8.92994 4.56176 8.90161 4.42747 8.90161H3.81072V10.0452ZM6.6383 8.25H7.11329H7.44405C7.68942 8.25 7.91324 8.29293 8.1155 8.37878C8.31943 8.46463 8.49516 8.5874 8.64272 8.74708C8.79193 8.90677 8.90716 9.09564 8.98839 9.3137C9.06963 9.53176 9.11025 9.77472 9.11025 10.0426V10.21C9.11025 10.4761 9.06963 10.7191 8.98839 10.9389C8.90716 11.1569 8.79193 11.3458 8.64272 11.5055C8.49516 11.6635 8.32025 11.7854 8.11799 11.8712C7.91572 11.9571 7.69273 12 7.44902 12H7.11329H6.65322H6.30257V8.25H6.6383ZM7.11329 11.351H7.44902C7.62973 11.351 7.78226 11.308 7.9066 11.2222C8.03095 11.1346 8.12545 11.0058 8.19011 10.8359C8.25477 10.6641 8.2871 10.4555 8.2871 10.21V10.0374C8.2871 9.85199 8.26886 9.68887 8.23238 9.54808C8.19591 9.40556 8.14203 9.28623 8.07074 9.19008C7.99945 9.09392 7.91075 9.02181 7.80464 8.97373C7.70019 8.92565 7.57999 8.90161 7.44405 8.90161H7.11329V11.351ZM10.4159 8.90161V9.83139H11.8408V10.4804H10.4159V12H9.60514V8.25H10.1896H10.4159H12V8.90161H10.4159Z"
        fill={fill ?? normalText.light}
      />
    </svg>
  );
}

function ImportIcon({ fill, width = '18', height = '18' }: IImportExportProps) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.5 11.25V13.5H4.5V11.25H3V13.5C3 14.325 3.675 15 4.5 15H13.5C14.325 15 15 14.325 15 13.5V11.25H13.5ZM5.25 6.75L6.3075 7.8075L8.25 5.8725V12H9.75V5.8725L11.6925 7.8075L12.75 6.75L9 3L5.25 6.75Z"
        fill={fill ?? normalText.light}
      />
    </svg>
  );
}

function ExportIcon({ fill, width = '18', height = '18' }: IImportExportProps) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.5 11.25V13.5H4.5V11.25H3V13.5C3 14.325 3.675 15 4.5 15H13.5C14.325 15 15 14.325 15 13.5V11.25H13.5ZM12.75 8.25L11.6925 7.1925L9.75 9.1275V3H8.25V9.1275L6.3075 7.1925L5.25 8.25L9 12L12.75 8.25Z"
        fill={fill ?? normalText.light}
      />
    </svg>
  );
}

export const AlertIcon = ({
  width,
  height,
}: {
  width?: string;
  height?: string;
}) => (
  <svg
    width={width || '56'}
    height={height || '56'}
    viewBox="0 0 56 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.43 47.8419H45.57C49.1633 47.8419 51.4033 43.9452 49.6067 40.8419L32.0367 10.4852C30.24 7.38188 25.76 7.38188 23.9633 10.4852L6.39333 40.8419C4.59666 43.9452 6.83666 47.8419 10.43 47.8419ZM28 31.5085C26.7167 31.5085 25.6667 30.4585 25.6667 29.1752V24.5085C25.6667 23.2252 26.7167 22.1752 28 22.1752C29.2833 22.1752 30.3333 23.2252 30.3333 24.5085V29.1752C30.3333 30.4585 29.2833 31.5085 28 31.5085ZM30.3333 40.8419H25.6667V36.1752H30.3333V40.8419Z"
      fill="#FBAD33"
    />
  </svg>
);

export const ReportProblemIcon = ({
  fillColor = '#E13939',
}: {
  fillColor?: string;
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="50"
    width="150"
    viewBox="0 0 24 24"
    fill={fillColor}
  >
    <path d="M4.47 21h15.06c1.54 0 2.5-1.67 1.73-3L13.73 4.99c-.77-1.33-2.69-1.33-3.46 0L2.74 18c-.77 1.33.19 3 1.73 3zM12 14c-.55 0-1-.45-1-1v-2c0-.55.45-1 1-1s1 .45 1 1v2c0 .55-.45 1-1 1zm1 4h-2v-2h2v2z" />
  </svg>
);

export const VariconIcon = () => <></>;

export const MyobIcon = () => <></>;

const AiSearchIconButton = () => (
  <svg
    width="30"
    height="24"
    viewBox="0 0 30 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.755 14.255H14.965L14.685 13.985C15.665 12.845 16.255 11.365 16.255 9.755C16.255 6.165 13.345 3.255 9.755 3.255C6.165 3.255 3.255 6.165 3.255 9.755C3.255 13.345 6.165 16.255 9.755 16.255C11.365 16.255 12.845 15.665 13.985 14.685L14.255 14.965V15.755L19.255 20.745L20.745 19.255L15.755 14.255ZM9.755 14.255C7.26501 14.255 5.255 12.245 5.255 9.755C5.255 7.265 7.26501 5.255 9.755 5.255C12.245 5.255 14.255 7.265 14.255 9.755C14.255 12.245 12.245 14.255 9.755 14.255Z"
      fill="white"
    />
    <path
      d="M22.611 9.07842L23.0254 10.2299C23.4863 11.5078 24.4926 12.514 25.7705 12.9749L26.9221 13.3892C27.026 13.4267 27.026 13.5738 26.9221 13.6113L25.7705 14.0256C24.4925 14.4865 23.4863 15.4927 23.0254 16.7706L22.611 17.9221C22.5736 18.026 22.4264 18.026 22.389 17.9221L21.9746 16.7706C21.5137 15.4926 20.5074 14.4865 19.2295 14.0256L18.0779 13.6113C17.974 13.5738 17.974 13.4267 18.0779 13.3892L19.2295 12.9749C20.5075 12.514 21.5137 11.5078 21.9746 10.2299L22.389 9.07842C22.4264 8.97386 22.5736 8.97386 22.611 9.07842Z"
      fill="white"
    />
    <path
      d="M28.0493 8.03527L28.2339 8.5466C28.4389 9.11402 28.8857 9.56137 29.4538 9.76636L29.9652 9.95096C30.0116 9.96795 30.0116 10.0331 29.9652 10.0495L29.4538 10.2341C28.8863 10.4391 28.4389 10.8859 28.2339 11.4539L28.0493 11.9652C28.0323 12.0116 27.9672 12.0116 27.9507 11.9652L27.7661 11.4539C27.5611 10.8864 27.1143 10.4391 26.5462 10.2341L26.0348 10.0495C25.9884 10.0325 25.9884 9.96738 26.0348 9.95096L26.5462 9.76636C27.1137 9.56137 27.5611 9.11458 27.7661 8.5466L27.9507 8.03527C27.9672 7.98827 28.0328 7.98827 28.0493 8.03527Z"
      fill="white"
    />
    <path
      d="M24.2808 6.02177L24.3962 6.34139C24.5243 6.69606 24.8036 6.97568 25.1586 7.10382L25.4782 7.21921C25.5073 7.22982 25.5073 7.27053 25.4782 7.28079L25.1586 7.39618C24.8039 7.52432 24.5243 7.80359 24.3962 8.15861L24.2808 8.47823C24.2702 8.50726 24.2295 8.50726 24.2192 8.47823L24.1038 8.15861C23.9757 7.80394 23.6964 7.52432 23.3414 7.39618L23.0218 7.28079C22.9927 7.27018 22.9927 7.22947 23.0218 7.21921L23.3414 7.10382C23.6961 6.97568 23.9757 6.69641 24.1038 6.34139L24.2192 6.02177C24.2295 5.99274 24.2705 5.99274 24.2808 6.02177Z"
      fill="white"
    />
  </svg>
);

const AiSearchIconSearchbar = () => (
  <svg
    width="30"
    height="24"
    viewBox="0 0 150 150"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M116.252 48.5315L119.061 56.3358C122.185 64.9976 129.005 71.8173 137.667 74.9407L145.472 77.7492C146.176 78.0029 146.176 79.0003 145.472 79.2541L137.667 82.0626C129.005 85.1861 122.185 92.006 119.061 100.667L116.252 108.472C115.999 109.176 115.001 109.176 114.748 108.472L111.939 100.667C108.815 92.0057 101.995 85.186 93.333 82.0626L85.5283 79.2541C84.8239 79.0004 84.8239 78.0029 85.5283 77.7492L93.333 74.9407C101.995 71.8172 108.815 64.9972 111.939 56.3358L114.748 48.5315C115.001 47.8228 115.999 47.8228 116.252 48.5315Z"
      fill="url(#paint0_linear_546_14629)"
    />
    <path
      d="M97.3203 23.2291L98.5203 26.5528C99.8529 30.241 102.757 33.1488 106.45 34.4813L109.774 35.6812C110.075 35.7916 110.075 36.2149 109.774 36.3216L106.45 37.5215C102.761 38.854 99.8529 41.7581 98.5203 45.4499L97.3203 48.7736C97.2098 49.0755 96.7865 49.0755 96.6797 48.7736L95.4797 45.4499C94.1471 41.7618 91.2427 38.854 87.5504 37.5215L84.2264 36.3216C83.9245 36.2112 83.9245 35.7879 84.2264 35.6812L87.5504 34.4813C91.239 33.1488 94.1471 30.2447 95.4797 26.5528L96.6797 23.2291C96.7865 22.9236 97.2135 22.9236 97.3203 23.2291Z"
      fill="url(#paint1_linear_546_14629)"
    />
    <path
      d="M74.8096 90.3125H70.3345L68.7483 88.7831C74.2998 82.3252 77.642 73.9413 77.642 64.821C77.642 44.4845 61.1575 28 40.821 28C20.4845 28 4 44.4845 4 64.821C4 85.1576 20.4845 101.642 40.821 101.642C49.9413 101.642 58.3251 98.2999 64.783 92.7484L66.3125 94.3345V98.8097L94.6363 127.077L103.077 118.636L74.8096 90.3125ZM40.821 90.3125C26.7157 90.3125 15.3295 78.9263 15.3295 64.821C15.3295 50.7158 26.7157 39.3296 40.821 39.3296C54.9263 39.3296 66.3125 50.7158 66.3125 64.821C66.3125 78.9263 54.9263 90.3125 40.821 90.3125Z"
      fill="url(#paint2_linear_546_14629)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_546_14629"
        x1="171"
        y1="61"
        x2="40.5213"
        y2="34.7489"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.0656686" stopColor="#6D50FF" />
        <stop offset="0.383285" stopColor="#60B5EA" />
        <stop offset="1" stopColor="#52D3C4" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_546_14629"
        x1="139"
        y1="16.5"
        x2="19.8589"
        y2="12.4408"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.00900758" stopColor="#6D50FF" />
        <stop offset="0.385054" stopColor="#60B5EA" />
        <stop offset="1" stopColor="#52D3C4" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_546_14629"
        x1="141"
        y1="48"
        x2="4.55346"
        y2="43.5159"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.00900758" stopColor="#6D50FF" />
        <stop offset="0.49" stopColor="#60B5EA" />
        <stop offset="1" stopColor="#52D3C4" />
      </linearGradient>
    </defs>
  </svg>
);

const AiSummaryIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_298_6337"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="24"
      height="24"
    >
      <rect width="24" height="24" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_298_6337)">
      <path
        d="M5 16.175C5.16667 16.125 5.32917 16.0833 5.4875 16.05C5.64583 16.0167 5.81667 16 6 16H7V4H6C5.71667 4 5.47917 4.09583 5.2875 4.2875C5.09583 4.47917 5 4.71667 5 5V16.175ZM6 22C5.16667 22 4.45833 21.7083 3.875 21.125C3.29167 20.5417 3 19.8333 3 19V5C3 4.16667 3.29167 3.45833 3.875 2.875C4.45833 2.29167 5.16667 2 6 2H13V4H9V16H15V13H17V18H6C5.71667 18 5.47917 18.0958 5.2875 18.2875C5.09583 18.4792 5 18.7167 5 19C5 19.2833 5.09583 19.5208 5.2875 19.7125C5.47917 19.9042 5.71667 20 6 20H19V12H21V22H6ZM17.5 12C17.5 10.4667 18.0333 9.16667 19.1 8.1C20.1667 7.03333 21.4667 6.5 23 6.5C21.4667 6.5 20.1667 5.96667 19.1 4.9C18.0333 3.83333 17.5 2.53333 17.5 1C17.5 2.53333 16.9667 3.83333 15.9 4.9C14.8333 5.96667 13.5333 6.5 12 6.5C13.5333 6.5 14.8333 7.03333 15.9 8.1C16.9667 9.16667 17.5 10.4667 17.5 12Z"
        fill="#596F96"
      />
    </g>
  </svg>
);

const GradientAutoAwesomeIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_483_11072)">
      <path
        d="M14.25 6.75L15.1875 4.6875L17.25 3.75L15.1875 2.8125L14.25 0.75L13.3125 2.8125L11.25 3.75L13.3125 4.6875L14.25 6.75ZM8.625 7.125L6.75 3L4.875 7.125L0.75 9L4.875 10.875L6.75 15L8.625 10.875L12.75 9L8.625 7.125ZM14.25 11.25L13.3125 13.3125L11.25 14.25L13.3125 15.1875L14.25 17.25L15.1875 15.1875L17.25 14.25L15.1875 13.3125L14.25 11.25Z"
        fill="url(#paint0_linear_483_11072)"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_483_11072"
        x1="16.15"
        y1="1.36875"
        x2="-0.773623"
        y2="9.50004"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.00900758" stopColor="#6D50FF" />
        <stop offset="0.49" stopColor="#60B5EA" />
        <stop offset="1" stopColor="#52D3C4" />
      </linearGradient>
      <clipPath id="clip0_483_11072">
        <rect width="18" height="18" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const GradientEnterIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.5 8.5L11.92 9.92L8.33 13.5H17.5V3.5H19.5V15.5H8.33L11.92 19.08L10.5 20.5L4.5 14.5L10.5 8.5Z"
      fill="url(#paint0_linear_549_14637)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_549_14637"
        x1="18.5"
        y1="4.1375"
        x2="2.44818"
        y2="10.9426"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.00900758" stopColor="#6D50FF" />
        <stop offset="0.49" stopColor="#60B5EA" />
        <stop offset="1" stopColor="#52D3C4" />
      </linearGradient>
    </defs>
  </svg>
);

const GradientVariconIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.30167 13.2931C5.16067 13.5472 5.16067 13.9553 5.30167 14.2004L7.31296 17.7756C7.48033 18.0748 7.75416 18.0748 7.92153 17.7756L17.5622 0.544307C17.7296 0.245058 17.5886 0 17.2534 0L13.2399 0.00911174C12.9574 0.00911174 12.6136 0.217723 12.4726 0.46278L5.30167 13.2931Z"
      fill="url(#paint0_linear_585_14991)"
    />
    <path
      d="M3.56263 3.80131L3.8828 4.69097C4.23888 5.67836 5.01637 6.45578 6.00378 6.81183L6.89348 7.13198C6.97377 7.16091 6.97377 7.27461 6.89348 7.30353L6.00378 7.62369C5.01633 7.97975 4.23887 8.75719 3.8828 9.74454L3.56263 10.6342C3.53371 10.7145 3.42 10.7145 3.39107 10.6342L3.0709 9.74454C2.71482 8.75715 1.93733 7.97973 0.949921 7.62369L0.0602195 7.30353C-0.0200732 7.27461 -0.0200732 7.16091 0.0602195 7.13198L0.949921 6.81183C1.93737 6.45576 2.71482 5.67832 3.0709 4.69097L3.39107 3.80131C3.41999 3.72053 3.5337 3.72053 3.56263 3.80131Z"
      fill="url(#paint1_linear_585_14991)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_585_14991"
        x1="19.0148"
        y1="-1.07902"
        x2="5.04649"
        y2="0.0900189"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.00900758" stopColor="#6D50FF" />
        <stop offset="0.49" stopColor="#60B5EA" />
        <stop offset="1" stopColor="#52D3C4" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_585_14991"
        x1="9.39948"
        y1="2.63772"
        x2="2.39783"
        y2="8.63229"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.00900758" stopColor="#6D50FF" />
        <stop offset="0.49" stopColor="#60B5EA" />
        <stop offset="1" stopColor="#52D3C4" />
      </linearGradient>
    </defs>
  </svg>
);

const AiBetaTagSearchBarIcon = () => (
  <svg
    width="57"
    height="24"
    viewBox="0 0 57 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M22.679 7.64182L23.1395 8.92122C23.6515 10.3412 24.7696 11.4592 26.1896 11.9712L27.4691 12.4316C27.5845 12.4732 27.5845 12.6367 27.4691 12.6783L26.1896 13.1387C24.7696 13.6508 23.6515 14.7688 23.1395 16.1887L22.679 17.4681C22.6374 17.5836 22.4739 17.5836 22.4323 17.4681L21.9719 16.1887C21.4598 14.7687 20.3417 13.6507 18.9217 13.1387L17.6423 12.6783C17.5268 12.6367 17.5268 12.4732 17.6423 12.4316L18.9217 11.9712C20.3418 11.4591 21.4598 10.3411 21.9719 8.92122L22.4323 7.64182C22.4739 7.52564 22.6374 7.52564 22.679 7.64182Z"
      fill="url(#paint0_linear_698_18484)"
    />
    <path
      d="M26.277 5.03917L26.4821 5.60732C26.7099 6.23778 27.2064 6.73483 27.8375 6.96261L28.4058 7.16772C28.4574 7.18659 28.4574 7.25895 28.4058 7.2772L27.8375 7.48231C27.207 7.71008 26.7099 8.20651 26.4821 8.8376L26.277 9.40575C26.2581 9.45734 26.1857 9.45734 26.1675 9.40575L25.9623 8.8376C25.7345 8.20714 25.2381 7.71008 24.6069 7.48231L24.0387 7.2772C23.9871 7.25832 23.9871 7.18596 24.0387 7.16772L24.6069 6.96261C25.2374 6.73483 25.7345 6.23841 25.9623 5.60732L26.1675 5.03917C26.1857 4.98694 26.2587 4.98694 26.277 5.03917Z"
      fill="url(#paint1_linear_698_18484)"
    />
    <path
      d="M19.4231 5.02419L19.5513 5.37932C19.6937 5.7734 20.004 6.08409 20.3985 6.22646L20.7536 6.35467C20.7858 6.36647 20.7858 6.4117 20.7536 6.42311L20.3985 6.55131C20.0044 6.69369 19.6937 7.00399 19.5513 7.39846L19.4231 7.75359C19.4113 7.78584 19.3661 7.78584 19.3547 7.75359L19.2265 7.39846C19.0841 7.00438 18.7738 6.69369 18.3793 6.55131L18.0242 6.42311C17.9919 6.41131 17.9919 6.36608 18.0242 6.35467L18.3793 6.22646C18.7734 6.08409 19.0841 5.77379 19.2265 5.37932L19.3547 5.02419C19.3661 4.99194 19.4117 4.99194 19.4231 5.02419Z"
      fill="url(#paint2_linear_698_18484)"
    />
    <path
      d="M16.2939 14.5786H15.3905L15.0703 14.2699C16.191 12.9663 16.8657 11.2739 16.8657 9.43282C16.8657 5.32762 13.538 2 9.43283 2C5.32762 2 2 5.32762 2 9.43282C2 13.538 5.32762 16.8656 9.43283 16.8656C11.2739 16.8656 12.9663 16.191 14.2699 15.0703L14.5786 15.3905V16.2939L20.2962 22L22 20.2962L16.2939 14.5786ZM9.43283 14.5786C6.58549 14.5786 4.28702 12.2802 4.28702 9.43282C4.28702 6.58548 6.58549 4.28702 9.43283 4.28702C12.2802 4.28702 14.5786 6.58548 14.5786 9.43282C14.5786 12.2802 12.2802 14.5786 9.43283 14.5786Z"
      fill="url(#paint3_linear_698_18484)"
    />
    <rect
      x="30"
      y="5.5"
      width="25"
      height="13"
      rx="2"
      fill="url(#paint4_linear_698_18484)"
    />
    <path
      d="M35.2109 11.9297H33.7617L33.7539 11.2148H35.0195C35.2331 11.2148 35.4141 11.1836 35.5625 11.1211C35.7135 11.056 35.8281 10.9635 35.9062 10.8438C35.9844 10.7214 36.0234 10.5742 36.0234 10.4023C36.0234 10.2122 35.987 10.0573 35.9141 9.9375C35.8411 9.81771 35.7292 9.73047 35.5781 9.67578C35.4297 9.62109 35.2396 9.59375 35.0078 9.59375H34.0586V14.5H33.0781V8.8125H35.0078C35.3203 8.8125 35.599 8.84245 35.8438 8.90234C36.0911 8.96224 36.3008 9.05599 36.4727 9.18359C36.6471 9.30859 36.7786 9.46745 36.8672 9.66016C36.9583 9.85286 37.0039 10.082 37.0039 10.3477C37.0039 10.582 36.9479 10.7969 36.8359 10.9922C36.724 11.1849 36.5586 11.3424 36.3398 11.4648C36.1211 11.5872 35.849 11.6602 35.5234 11.6836L35.2109 11.9297ZM35.168 14.5H33.4531L33.8945 13.7227H35.168C35.3893 13.7227 35.5742 13.6862 35.7227 13.6133C35.8711 13.5378 35.9818 13.4349 36.0547 13.3047C36.1302 13.1719 36.168 13.0169 36.168 12.8398C36.168 12.6549 36.1354 12.4948 36.0703 12.3594C36.0052 12.2214 35.9023 12.1159 35.7617 12.043C35.6211 11.9674 35.4375 11.9297 35.2109 11.9297H34.1094L34.1172 11.2148H35.5508L35.7734 11.4844C36.0859 11.4948 36.3424 11.5638 36.543 11.6914C36.7461 11.819 36.8971 11.9844 36.9961 12.1875C37.0951 12.3906 37.1445 12.6094 37.1445 12.8438C37.1445 13.2057 37.0651 13.5091 36.9062 13.7539C36.75 13.9987 36.5247 14.1849 36.2305 14.3125C35.9362 14.4375 35.582 14.5 35.168 14.5ZM42.0055 13.7227V14.5H38.9859V13.7227H42.0055ZM39.2633 8.8125V14.5H38.2828V8.8125H39.2633ZM41.6109 11.1875V11.9531H38.9859V11.1875H41.6109ZM41.9859 8.8125V9.59375H38.9859V8.8125H41.9859ZM45.3742 8.8125V14.5H44.4016V8.8125H45.3742ZM47.1594 8.8125V9.59375H42.632V8.8125H47.1594ZM49.8992 9.57031L48.2 14.5H47.1727L49.3133 8.8125H49.9695L49.8992 9.57031ZM51.3211 14.5L49.618 9.57031L49.5437 8.8125H50.2039L52.3523 14.5H51.3211ZM51.2391 12.3906V13.168H48.1453V12.3906H51.2391Z"
      fill="white"
    />
    <defs>
      <linearGradient
        id="paint0_linear_698_18484"
        x1="26.889"
        y1="7.92969"
        x2="16.6323"
        y2="12.8578"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.00900758" stopColor="#6D50FF" />
        <stop offset="0.49" stopColor="#60B5EA" />
        <stop offset="1" stopColor="#52D3C4" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_698_18484"
        x1="28.1482"
        y1="5.16667"
        x2="23.5896"
        y2="7.35692"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.00900758" stopColor="#6D50FF" />
        <stop offset="0.49" stopColor="#60B5EA" />
        <stop offset="1" stopColor="#52D3C4" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_698_18484"
        x1="20.5926"
        y1="5.10417"
        x2="17.7435"
        y2="6.47307"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.00900758" stopColor="#6D50FF" />
        <stop offset="0.49" stopColor="#60B5EA" />
        <stop offset="1" stopColor="#52D3C4" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_698_18484"
        x1="20.6667"
        y1="2.75"
        x2="0.153194"
        y2="12.6061"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.00900758" stopColor="#6D50FF" />
        <stop offset="0.49" stopColor="#60B5EA" />
        <stop offset="1" stopColor="#52D3C4" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_698_18484"
        x1="53.3333"
        y1="5.9875"
        x2="36.3076"
        y2="21.719"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.00900758" stopColor="#6D50FF" />
        <stop offset="0.49" stopColor="#60B5EA" />
        <stop offset="1" stopColor="#52D3C4" />
      </linearGradient>
    </defs>
  </svg>
);

const PolishNoteIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.49902 17.501H5.62402L14.8407 8.28432L11.7157 5.15932L2.49902 14.376V17.501ZM4.16569 15.0676L11.7157 7.51765L12.4824 8.28432L4.93236 15.8343H4.16569V15.0676Z"
      fill="url(#paint0_linear_761_27202)"
    />
    <path
      d="M15.3074 2.74265C14.9824 2.41765 14.4574 2.41765 14.1324 2.74265L12.6074 4.26765L15.7324 7.39265L17.2574 5.86765C17.5824 5.54265 17.5824 5.01765 17.2574 4.69265L15.3074 2.74265Z"
      fill="url(#paint1_linear_761_27202)"
    />
    <path
      d="M8.19676 5.25317C7.26095 5.31063 6.37845 5.70829 5.71549 6.37125C5.05253 7.03421 4.65487 7.91671 4.59741 8.85252H4.58299C4.52564 7.91668 4.12801 7.03411 3.46503 6.37113C2.80205 5.70815 1.91949 5.31052 0.983643 5.25317V5.23875C1.91949 5.1814 2.80205 4.78377 3.46503 4.12079C4.12801 3.45781 4.52564 2.57525 4.58299 1.6394H4.59741C4.65487 2.57521 5.05253 3.45771 5.71549 4.12067C6.37845 4.78363 7.26095 5.18129 8.19676 5.23875V5.25317Z"
      fill="url(#paint2_linear_761_27202)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_761_27202"
        x1="16.501"
        y1="3.06148"
        x2="1.11372"
        y2="10.4546"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.00900758" stopColor="#6D50FF" />
        <stop offset="0.49" stopColor="#60B5EA" />
        <stop offset="1" stopColor="#52D3C4" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_761_27202"
        x1="16.501"
        y1="3.06148"
        x2="1.11372"
        y2="10.4546"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.00900758" stopColor="#6D50FF" />
        <stop offset="0.49" stopColor="#60B5EA" />
        <stop offset="1" stopColor="#52D3C4" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_761_27202"
        x1="7.71588"
        y1="1.9099"
        x2="0.317578"
        y2="5.46456"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.00900758" stopColor="#6D50FF" />
        <stop offset="0.49" stopColor="#60B5EA" />
        <stop offset="1" stopColor="#52D3C4" />
      </linearGradient>
    </defs>
  </svg>
);

const TagGeneratorIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.7266 8.535L17.8417 9.65008C18.1417 9.95008 18.3334 10.3751 18.3334 10.8334C18.3334 11.2917 18.15 11.7084 17.8417 12.0084L12.0084 17.8417C11.7084 18.1501 11.2917 18.3334 10.8334 18.3334C10.375 18.3334 9.95835 18.1501 9.65835 17.8501L2.15835 10.3501C1.85002 10.0417 1.66669 9.62508 1.66669 9.16675V3.33341C1.66669 2.41675 2.41669 1.66675 3.33335 1.66675H9.16669C9.62502 1.66675 10.0417 1.85008 10.3417 2.15008L12.0125 3.82091L10.8375 4.99591L9.16669 3.32508V3.33341H3.33335V9.16675L10.8334 16.6751L16.6667 10.8251L15.5516 9.71L16.7266 8.535ZM6.66669 5.41675C6.66669 6.10711 6.10705 6.66675 5.41669 6.66675C4.72633 6.66675 4.16669 6.10711 4.16669 5.41675C4.16669 4.72639 4.72633 4.16675 5.41669 4.16675C6.10705 4.16675 6.66669 4.72639 6.66669 5.41675Z"
      fill="url(#paint0_linear_831_1154)"
    />
    <path
      d="M17.5 6.4235C16.6351 6.4766 15.8195 6.84414 15.2068 7.45687C14.594 8.06961 14.2265 8.88524 14.1734 9.75015H14.16C14.107 8.88524 13.7395 8.06952 13.1268 7.45676C12.514 6.844 11.6983 6.4765 10.8334 6.4235V6.41016C11.6983 6.35716 12.514 5.98966 13.1268 5.3769C13.7395 4.76415 14.107 3.94845 14.16 3.0835H14.1734C14.2265 3.94841 14.594 4.76405 15.2068 5.37679C15.8195 5.98953 16.6351 6.35706 17.5 6.41016V6.4235Z"
      fill="url(#paint1_linear_831_1154)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_831_1154"
        x1="17.2222"
        y1="2.29175"
        x2="0.127674"
        y2="10.5052"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.00900758" stopColor="#6D50FF" />
        <stop offset="0.49" stopColor="#60B5EA" />
        <stop offset="1" stopColor="#52D3C4" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_831_1154"
        x1="17.0556"
        y1="3.3335"
        x2="10.2178"
        y2="6.61887"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.00900758" stopColor="#6D50FF" />
        <stop offset="0.49" stopColor="#60B5EA" />
        <stop offset="1" stopColor="#52D3C4" />
      </linearGradient>
    </defs>
  </svg>
);

const FileNameGeneratorIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.5 13.3333L9.16667 16.6666H17.5V13.3333H12.5Z"
      fill="url(#paint0_linear_831_2069)"
    />
    <path
      d="M10.05 5.99159L2.5 13.5416V16.6666H5.625L13.175 9.11658L10.05 5.99159ZM4.93333 14.9999H4.16667V14.2333L10.05 8.34992L10.8167 9.11658L4.93333 14.9999Z"
      fill="url(#paint1_linear_831_2069)"
    />
    <path
      d="M15.5917 6.69992C15.9167 6.37492 15.9167 5.84992 15.5917 5.52492L13.6417 3.57492C13.475 3.40825 13.2667 3.33325 13.05 3.33325C12.8417 3.33325 12.625 3.41659 12.4667 3.57492L10.9417 5.09992L14.0667 8.22492L15.5917 6.69992Z"
      fill="url(#paint2_linear_831_2069)"
    />
    <path
      d="M8.33335 4.00675C7.46844 4.05985 6.6528 4.42739 6.04006 5.04012C5.42733 5.65286 5.05979 6.4685 5.00669 7.33341H4.99335C4.94035 6.46847 4.57285 5.65277 3.96009 5.04001C3.34733 4.42725 2.53163 4.05975 1.66669 4.00675V3.99341C2.53163 3.94041 3.34733 3.57291 3.96009 2.96015C4.57285 2.34739 4.94035 1.53169 4.99335 0.666748H5.00669C5.05979 1.53166 5.42733 2.3473 6.04006 2.96004C6.6528 3.57278 7.46844 3.94031 8.33335 3.99341V4.00675Z"
      fill="url(#paint3_linear_831_2069)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_831_2069"
        x1="16.5"
        y1="3.83325"
        x2="1.84499"
        y2="11.7547"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.00900758" stopColor="#6D50FF" />
        <stop offset="0.49" stopColor="#60B5EA" />
        <stop offset="1" stopColor="#52D3C4" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_831_2069"
        x1="16.5"
        y1="3.83325"
        x2="1.84499"
        y2="11.7547"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.00900758" stopColor="#6D50FF" />
        <stop offset="0.49" stopColor="#60B5EA" />
        <stop offset="1" stopColor="#52D3C4" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_831_2069"
        x1="16.5"
        y1="3.83325"
        x2="1.84499"
        y2="11.7547"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.00900758" stopColor="#6D50FF" />
        <stop offset="0.49" stopColor="#60B5EA" />
        <stop offset="1" stopColor="#52D3C4" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_831_2069"
        x1="7.88891"
        y1="0.916748"
        x2="1.05108"
        y2="4.20212"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.00900758" stopColor="#6D50FF" />
        <stop offset="0.49" stopColor="#60B5EA" />
        <stop offset="1" stopColor="#52D3C4" />
      </linearGradient>
    </defs>
  </svg>
);

const AiSparkleSummaryIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_473_12541"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="24"
      height="24"
    >
      <rect width="24" height="24" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_473_12541)">
      <path
        d="M5 16.175C5.16667 16.125 5.32917 16.0833 5.4875 16.05C5.64583 16.0167 5.81667 16 6 16H7V4H6C5.71667 4 5.47917 4.09583 5.2875 4.2875C5.09583 4.47917 5 4.71667 5 5V16.175ZM6 22C5.16667 22 4.45833 21.7083 3.875 21.125C3.29167 20.5417 3 19.8333 3 19V5C3 4.16667 3.29167 3.45833 3.875 2.875C4.45833 2.29167 5.16667 2 6 2H13V4H9V16H15V13H17V18H6C5.71667 18 5.47917 18.0958 5.2875 18.2875C5.09583 18.4792 5 18.7167 5 19C5 19.2833 5.09583 19.5208 5.2875 19.7125C5.47917 19.9042 5.71667 20 6 20H19V12H21V22H6ZM17.5 12C17.5 10.4667 18.0333 9.16667 19.1 8.1C20.1667 7.03333 21.4667 6.5 23 6.5C21.4667 6.5 20.1667 5.96667 19.1 4.9C18.0333 3.83333 17.5 2.53333 17.5 1C17.5 2.53333 16.9667 3.83333 15.9 4.9C14.8333 5.96667 13.5333 6.5 12 6.5C13.5333 6.5 14.8333 7.03333 15.9 8.1C16.9667 9.16667 17.5 10.4667 17.5 12Z"
        fill="url(#paint0_linear_473_12541)"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_473_12541"
        x1="21.6667"
        y1="1.7875"
        x2="0.789143"
        y2="11.3409"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.00900758" stopColor="#6D50FF" />
        <stop offset="0.49" stopColor="#60B5EA" />
        <stop offset="1" stopColor="#52D3C4" />
      </linearGradient>
    </defs>
  </svg>
);

const AISummaryIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11 8H4V20.2197H16V13H18V20C18 21.1 17.1 22 16 22H4C2.9 22 2 21.1 2 20V8C2 6.9 2.9 6 4 6H11V8ZM14 18H6V16H14V18ZM14 15H6V13H14V15ZM14 12H6V10H14V12ZM17.0098 2C17.0894 3.29737 17.6414 4.52035 18.5605 5.43945C19.4797 6.35856 20.7026 6.91058 22 6.99023V7.00977C20.7026 7.08942 19.4797 7.64144 18.5605 8.56055C17.6414 9.47965 17.0894 10.7026 17.0098 12H16.9902C16.9107 10.7026 16.3596 9.47871 15.4404 8.55957C14.5213 7.64044 13.2974 7.08927 12 7.00977V6.99023C13.2974 6.91073 14.5213 6.35957 15.4404 5.44043C16.3596 4.52129 16.9107 3.29742 16.9902 2H17.0098Z"
      fill="url(#paint0_linear_861_6420)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_861_6420"
        x1="20.6667"
        y1="2.75"
        x2="0.153185"
        y2="12.6061"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.00900758" stopColor="#6D50FF" />
        <stop offset="0.49" stopColor="#60B5EA" />
        <stop offset="1" stopColor="#52D3C4" />
      </linearGradient>
    </defs>
  </svg>
);

const TalkWithDocsFileManagerIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.403 0.666748C9.27532 1.41619 8.4706 2.61087 8.23746 4.00008H3.99999V5.66675H8.23746C8.28559 5.95357 8.35754 6.23203 8.4523 6.50008H3.99999V8.16675H9.44107C9.72466 8.48348 10.0477 8.76394 10.403 9.00008H3.99999V10.6667H10.6667V9.16283C11.4022 9.5885 12.2557 9.83342 13.1667 9.83342C14.9062 9.83342 16.4377 8.94478 17.3333 7.59709V12.3334C17.3333 13.2501 16.5833 14.0001 15.6667 14.0001H3.99999L0.666656 17.3334L0.674795 2.33341C0.674795 1.41675 1.41666 0.666748 2.33332 0.666748H10.403ZM13.1748 0.666748C13.2412 1.74789 13.7012 2.76704 14.4671 3.53296C15.2331 4.29888 16.2522 4.7589 17.3333 4.82527V4.84156C16.2522 4.90793 15.2331 5.36795 14.4671 6.13387C13.7012 6.89979 13.2412 7.91894 13.1748 9.00008H13.1585C13.0922 7.9189 12.633 6.89901 11.867 6.13306C11.1011 5.36711 10.0812 4.90781 8.99999 4.84156V4.82527C10.0812 4.75902 11.1011 4.29972 11.867 3.53377C12.633 2.76782 13.0922 1.74793 13.1585 0.666748H13.1748Z"
      fill="url(#paint0_linear_900_2479)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_900_2479"
        x1="16.2222"
        y1="1.29175"
        x2="-0.872356"
        y2="9.50517"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.00900758" stopColor="#6D50FF" />
        <stop offset="0.49" stopColor="#60B5EA" />
        <stop offset="1" stopColor="#52D3C4" />
      </linearGradient>
    </defs>
  </svg>
);

const VariconSparkleIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.10028 16.2721C7.9529 16.5262 7.9529 16.9344 8.10028 17.1794L10.2026 20.7546C10.3776 21.0538 10.6638 21.0538 10.8388 20.7546L20.9159 3.52331C21.0909 3.22406 20.9435 2.979 20.5931 2.979L16.3979 2.98812C16.1027 2.98812 15.7433 3.19673 15.5959 3.44178L8.10028 16.2721Z"
      fill="url(#paint0_linear_892_18825)"
    />
    <path
      d="M6.57609 7.03999L6.89839 7.93557C7.25685 8.92954 8.03949 9.71214 9.03349 10.0705L9.9291 10.3928C10.01 10.4219 10.01 10.5364 9.9291 10.5656L9.03349 10.8878C8.03949 11.2462 7.25684 12.0288 6.89839 13.0228L6.57609 13.9184C6.54698 13.9992 6.43251 13.9992 6.40339 13.9184L6.08109 13.0228C5.72263 12.0288 4.93997 11.2462 3.94599 10.8878L3.05037 10.5656C2.96954 10.5364 2.96954 10.4219 3.05037 10.3928L3.94599 10.0705C4.94001 9.71214 5.72264 8.92949 6.08109 7.93557L6.40339 7.03999C6.4325 6.95867 6.54697 6.95867 6.57609 7.03999Z"
      fill="url(#paint1_linear_892_18825)"
    />
    <path
      d="M8.52675 4.00465L8.66488 4.38847C8.8185 4.81446 9.15392 5.14986 9.57992 5.30346L9.96375 5.44158C9.99841 5.45406 9.99841 5.50311 9.96375 5.51561L9.57992 5.65371C9.15392 5.80733 8.8185 6.14273 8.66488 6.56871L8.52675 6.95252C8.51427 6.98718 8.46522 6.98718 8.45274 6.95252L8.31461 6.56871C8.16098 6.14273 7.82556 5.80733 7.39957 5.65371L7.01573 5.51561C6.98109 5.50311 6.98109 5.45406 7.01573 5.44158L7.39957 5.30346C7.82557 5.14986 8.16099 4.81444 8.31461 4.38847L8.45274 4.00465C8.46521 3.9698 8.51427 3.9698 8.52675 4.00465Z"
      fill="url(#paint2_linear_892_18825)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_892_18825"
        x1="7.06088"
        y1="16.4976"
        x2="22.4398"
        y2="5.14431"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F37921" />
        <stop offset="1" stopColor="#FBAD35" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_892_18825"
        x1="3.93174"
        y1="18.8775"
        x2="11.9509"
        y2="17.3334"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#243859" />
        <stop offset="0.191" stopColor="#2C3959" />
        <stop offset="0.5025" stopColor="#3D3D58" />
        <stop offset="0.8935" stopColor="#554556" />
        <stop offset="1" stopColor="#5C4755" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_892_18825"
        x1="7.39346"
        y1="9.07788"
        x2="10.8302"
        y2="8.41611"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#243859" />
        <stop offset="0.191" stopColor="#2C3959" />
        <stop offset="0.5025" stopColor="#3D3D58" />
        <stop offset="0.8935" stopColor="#554556" />
        <stop offset="1" stopColor="#5C4755" />
      </linearGradient>
    </defs>
  </svg>
);

function UnVerifiedIcon({ color = '#FF2929', size = '16' }) {
  return (
    <svg
      fontSize={size}
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 4.25C8.4125 4.25 8.75 4.5875 8.75 5V8C8.75 8.4125 8.4125 8.75 8 8.75C7.5875 8.75 7.25 8.4125 7.25 8V5C7.25 4.5875 7.5875 4.25 8 4.25ZM7.9925 0.5C3.8525 0.5 0.5 3.86 0.5 8C0.5 12.14 3.8525 15.5 7.9925 15.5C12.14 15.5 15.5 12.14 15.5 8C15.5 3.86 12.14 0.5 7.9925 0.5ZM8 14C4.685 14 2 11.315 2 8C2 4.685 4.685 2 8 2C11.315 2 14 4.685 14 8C14 11.315 11.315 14 8 14ZM8.75 11.75H7.25V10.25H8.75V11.75Z"
        fill={color}
      />
    </svg>
  );
}
const WarningFilledIcon = () => (
  <svg
    width="46"
    height="40"
    viewBox="0 0 46 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.43158 39.8424H40.5716C44.1649 39.8424 46.4049 35.9457 44.6083 32.8424L27.0382 2.4857C25.2416 -0.61763 20.7616 -0.61763 18.9649 2.4857L1.39492 32.8424C-0.401748 35.9457 1.83825 39.8424 5.43158 39.8424ZM23.0016 23.509C21.7183 23.509 20.6683 22.459 20.6683 21.1757V16.509C20.6683 15.2257 21.7183 14.1757 23.0016 14.1757C24.2849 14.1757 25.3349 15.2257 25.3349 16.509V21.1757C25.3349 22.459 24.2849 23.509 23.0016 23.509ZM25.3349 32.8424H20.6683V28.1757H25.3349V32.8424Z"
      fill="#FBAD33"
    />
  </svg>
);

const EquipmentIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.3785 9.07961C11.5332 9.02751 11.6965 9.00042 11.8612 9.00042H12.3247C12.339 9.00045 12.3531 8.99755 12.3662 8.9919C12.3793 8.98625 12.3911 8.97797 12.4009 8.96758C12.4106 8.95718 12.4181 8.94489 12.423 8.93147C12.4278 8.91805 12.4298 8.90378 12.4289 8.88954L12.2413 6.17268C12.2384 6.12019 12.215 6.07096 12.1761 6.03562C12.1371 6.00029 12.0859 5.98169 12.0333 5.98385C10.2552 6.07389 8.82629 7.39522 8.71666 9.20758L8.70207 9.44892C8.70013 9.48143 8.70583 9.51394 8.71871 9.54385C8.7316 9.57375 8.75132 9.60022 8.77628 9.62113C8.80125 9.64205 8.83076 9.65681 8.86247 9.66426C8.89417 9.6717 8.92717 9.67162 8.95884 9.664L11.3785 9.07961ZM3.37038 1.49805C3.12029 1.49797 2.87438 1.56218 2.65625 1.68452C2.43813 1.80686 2.25511 1.98322 2.12478 2.19667C1.99445 2.41012 1.92118 2.65349 1.91201 2.90342C1.90283 3.15334 1.95806 3.40143 2.07239 3.62386L1.58887 9.15763C1.588 9.1665 1.58744 9.1754 1.58721 9.18431L1.55303 10.1513C1.53503 10.6608 1.70914 11.1583 2.04082 11.5454C2.37251 11.9324 2.83755 12.1807 3.34371 12.2409L3.41874 12.2501C3.81375 12.2972 4.21389 12.2273 4.56955 12.0491C4.92521 11.8709 5.22074 11.5922 5.4195 11.2476L6.33443 9.66116C6.54076 9.30394 6.21855 8.87377 5.81757 8.97131L5.11688 9.14137L4.05481 9.0726L3.61048 9.01966L4.31574 4.34205C5.07228 4.5763 5.81923 4.82473 6.46365 5.17653C7.0868 5.51708 7.58407 5.93891 7.88794 6.50954C7.33566 7.28053 7.01492 8.19314 6.96342 9.14012L6.83379 11.4785C6.83061 11.5351 6.83902 11.5918 6.85848 11.645C6.87795 11.6982 6.90808 11.747 6.94702 11.7882C6.98595 11.8294 7.03289 11.8622 7.08494 11.8846C7.137 11.9071 7.19309 11.9187 7.24978 11.9187H16.274C16.3028 11.9187 16.3313 11.9127 16.3577 11.9011C16.3841 11.8895 16.4077 11.8726 16.4273 11.8514C16.4468 11.8302 16.4617 11.8052 16.471 11.778C16.4804 11.7508 16.484 11.7219 16.4816 11.6932L16.2357 8.74039C16.2226 8.58411 16.1513 8.43846 16.0359 8.3323C15.9205 8.22614 15.7694 8.16723 15.6125 8.16725H14.0178C14.0127 8.1673 14.0078 8.16551 14.004 8.16222C14.0001 8.15892 13.9976 8.15434 13.9969 8.14933L13.5784 5.13485C13.5508 4.93552 13.4519 4.75293 13.3002 4.62077C13.1484 4.48862 12.9539 4.41583 12.7527 4.41583H11.9578C11.2004 4.41583 10.481 4.58464 9.83576 4.88725C8.62113 3.04989 6.49616 2.53219 4.56334 2.11703C4.42878 1.92568 4.25012 1.76954 4.04248 1.6618C3.83484 1.55406 3.60431 1.49789 3.37038 1.49805ZM2.74515 2.95694C2.74515 2.79111 2.81102 2.63208 2.92827 2.51483C3.04553 2.39757 3.20456 2.3317 3.37038 2.3317C3.53621 2.3317 3.69524 2.39757 3.81249 2.51483C3.92975 2.63208 3.99562 2.79111 3.99562 2.95694C3.99562 3.12276 3.92975 3.28179 3.81249 3.39905C3.69524 3.5163 3.53621 3.58217 3.37038 3.58217C3.20456 3.58217 3.04553 3.5163 2.92827 3.39905C2.81102 3.28179 2.74515 3.12276 2.74515 2.95694Z"
      fill="#5F6D83"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.23799 12.8947C7.46556 12.8005 7.70947 12.752 7.95579 12.752H14.625C14.8713 12.752 15.1152 12.8005 15.3428 12.8947C15.5704 12.989 15.7772 13.1272 15.9513 13.3013C16.1255 13.4755 16.2637 13.6823 16.3579 13.9099C16.4522 14.1374 16.5007 14.3813 16.5007 14.6277C16.5007 14.874 16.4522 15.1179 16.3579 15.3455C16.2637 15.573 16.1255 15.7798 15.9513 15.954C15.7772 16.1282 15.5704 16.2663 15.3428 16.3606C15.1152 16.4549 14.8713 16.5034 14.625 16.5034H7.95579C7.70947 16.5034 7.46556 16.4549 7.23799 16.3606C7.01042 16.2663 6.80364 16.1282 6.62946 15.954C6.45529 15.7798 6.31712 15.573 6.22286 15.3455C6.1286 15.1179 6.08008 14.874 6.08008 14.6277C6.08008 14.3813 6.1286 14.1374 6.22286 13.9099C6.31712 13.6823 6.45529 13.4755 6.62946 13.3013C6.80364 13.1272 7.01042 12.989 7.23799 12.8947ZM9.23145 15.0697C9.11419 15.187 8.95516 15.2529 8.78934 15.2529C8.62351 15.2529 8.46448 15.187 8.34723 15.0697C8.22997 14.9525 8.1641 14.7935 8.1641 14.6276C8.1641 14.4618 8.22997 14.3028 8.34723 14.1855C8.46448 14.0683 8.62351 14.0024 8.78934 14.0024C8.95516 14.0024 9.11419 14.0683 9.23145 14.1855C9.3487 14.3028 9.41458 14.4618 9.41458 14.6276C9.41458 14.7935 9.3487 14.9525 9.23145 15.0697ZM11.7324 15.0697C11.8497 14.9525 11.9155 14.7935 11.9155 14.6276C11.9155 14.4618 11.8497 14.3028 11.7324 14.1855C11.6151 14.0683 11.4561 14.0024 11.2903 14.0024C11.1245 14.0024 10.9654 14.0683 10.8482 14.1855C10.7309 14.3028 10.6651 14.4618 10.6651 14.6276C10.6651 14.7935 10.7309 14.9525 10.8482 15.0697C10.9654 15.187 11.1245 15.2529 11.2903 15.2529C11.4561 15.2529 11.6151 15.187 11.7324 15.0697ZM13.7912 15.2529C13.9571 15.2529 14.1161 15.187 14.2334 15.0697C14.3506 14.9525 14.4165 14.7935 14.4165 14.6276C14.4165 14.4618 14.3506 14.3028 14.2334 14.1855C14.1161 14.0683 13.9571 14.0024 13.7912 14.0024C13.6254 14.0024 13.4664 14.0683 13.3491 14.1855C13.2319 14.3028 13.166 14.4618 13.166 14.6276C13.166 14.7935 13.2319 14.9525 13.3491 15.0697C13.4664 15.187 13.6254 15.2529 13.7912 15.2529Z"
      fill="#5F6D83"
    />
  </svg>
);

const EmployeeIcon = () => (
  <svg
    width="12"
    height="13"
    viewBox="0 0 12 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6 9.00004C3.05334 9.00004 0.666672 10.1934 0.666672 11.6667V13H11.3333V11.6667C11.3333 10.1934 8.94667 9.00004 6 9.00004ZM3.33334 5.00004C3.33334 5.70728 3.61429 6.38556 4.11439 6.88566C4.61448 7.38576 5.29276 7.66671 6 7.66671C6.70725 7.66671 7.38553 7.38576 7.88562 6.88566C8.38572 6.38556 8.66667 5.70728 8.66667 5.00004M5.66667 0.333374C5.46667 0.333374 5.33334 0.473374 5.33334 0.666707V2.66671H4.66667V1.00004C4.66667 1.00004 3.16667 1.57337 3.16667 3.50004C3.16667 3.50004 2.66667 3.59337 2.66667 4.33337H9.33334C9.3 3.59337 8.83334 3.50004 8.83334 3.50004C8.83334 1.57337 7.33334 1.00004 7.33334 1.00004V2.66671H6.66667V0.666707C6.66667 0.473374 6.54 0.333374 6.33334 0.333374H5.66667Z"
      fill="#00050A"
      fillOpacity="0.64"
    />
  </svg>
);

const GuidedTourIcon = () => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M40.7111 16.5667H40.0427V15.8909C40.0427 14.776 39.1403 13.8637 38.0375 13.8637H31.0791C31.2596 13.215 31.3532 12.5325 31.3532 11.8365C31.3532 9.72824 30.4575 7.70779 28.9067 6.29574C27.5498 5.07267 25.792 4.40369 23.974 4.40369C23.7066 4.40369 23.4325 4.42396 23.1652 4.45099C19.8833 4.81589 17.1693 7.48502 16.7219 10.7828C16.5748 11.8437 16.6484 12.8843 16.9224 13.8641H9.96406C8.86118 13.8641 7.95881 14.7764 7.95881 15.8913V16.567H7.2904C6.18753 16.567 5.28516 17.4793 5.28516 18.5942V41.5691C5.28516 42.6841 6.18753 43.5963 7.2904 43.5963H40.7111C41.814 43.5963 42.7163 42.6841 42.7163 41.5691V18.5942C42.7163 17.4793 41.814 16.5667 40.7111 16.5667ZM38.0375 15.2152C38.4051 15.2152 38.7059 15.5193 38.7059 15.8909V38.8658C38.7059 39.2375 38.4051 39.5416 38.0375 39.5416H24.6692V26.0269H25.3376C26.4405 26.0269 27.3428 25.1147 27.3428 23.9997V21.1752C27.3428 19.7156 27.9712 18.2898 29.1141 17.1748C29.709 16.6005 30.1903 15.9382 30.5512 15.2152L38.0375 15.2152ZM18.0454 10.9716C18.2258 9.62013 18.8742 8.40381 19.81 7.48481C20.7457 6.56582 21.969 5.94414 23.3125 5.7955C25.057 5.59954 26.7214 6.13337 28.0112 7.3024C29.2879 8.45791 30.0165 10.1067 30.0165 11.8364C30.0165 12.6676 29.8561 13.4717 29.5419 14.2082C29.5285 14.242 29.5152 14.2758 29.5018 14.3028C29.1943 15.0056 28.7465 15.6476 28.185 16.2016C26.9217 17.4382 26.1731 18.9857 26.0328 20.621H21.9755C21.8351 18.979 21.0865 17.4113 19.87 16.2557C19.2818 15.6948 18.8206 15.0326 18.4997 14.3096C18.4864 14.2826 18.473 14.2488 18.4663 14.215C18.0385 13.2149 17.8916 12.1068 18.0454 10.9716ZM9.29587 15.8909C9.29587 15.5193 9.59665 15.2152 9.96428 15.2152H17.4505C17.8248 15.9585 18.3328 16.6477 18.9544 17.2424C20.0372 18.2695 20.6589 19.7088 20.6589 21.1752V23.9997C20.6589 25.1147 21.5613 26.0269 22.6642 26.0269H23.3326V39.5416H9.96428C9.59665 39.5416 9.29587 39.2375 9.29587 38.8658V15.8909Z"
      fill="#0075E0"
    />
    <path
      d="M23.4846 13.9728V18.7156C23.4846 19.0789 23.7157 19.3762 23.9983 19.3762C24.2809 19.3762 24.5121 19.0789 24.5121 18.7156V13.9728C25.108 13.702 25.5396 12.9754 25.5396 12.1101C25.5396 11.7468 25.3084 11.4496 25.0258 11.4496C24.7433 11.4496 24.5121 11.7468 24.5121 12.1101C24.5121 12.4734 24.2809 12.7707 23.9983 12.7707C23.7157 12.7707 23.4846 12.4734 23.4846 12.1101C23.4846 11.7468 23.2534 11.4496 22.9708 11.4496C22.6882 11.4496 22.457 11.7468 22.457 12.1101C22.457 12.9688 22.8886 13.6954 23.4846 13.9728Z"
      fill="#0075E0"
    />
    <path
      d="M12.1245 28.6238H20.9024C21.2738 28.6238 21.5777 28.3266 21.5777 27.9633C21.5777 27.6 21.2738 27.3027 20.9024 27.3027H12.1245C11.7531 27.3027 11.4492 27.6 11.4492 27.9633C11.4492 28.3266 11.7531 28.6238 12.1245 28.6238Z"
      fill="#0075E0"
    />
    <path
      d="M12.1245 32.5872H20.9024C21.2738 32.5872 21.5777 32.29 21.5777 31.9267C21.5777 31.5634 21.2738 31.2661 20.9024 31.2661H12.1245C11.7531 31.2661 11.4492 31.5634 11.4492 31.9267C11.4492 32.29 11.7531 32.5872 12.1245 32.5872Z"
      fill="#0075E0"
    />
    <path
      d="M12.1245 36.9908H20.9024C21.2738 36.9908 21.5777 36.5945 21.5777 36.1101C21.5777 35.6257 21.2738 35.2294 20.9024 35.2294H12.1245C11.7531 35.2294 11.4492 35.6257 11.4492 36.1101C11.4492 36.5945 11.7531 36.9908 12.1245 36.9908Z"
      fill="#0075E0"
    />
    <path
      d="M26.4219 27.9633C26.4219 28.3266 26.7257 28.6238 27.0971 28.6238H35.8751C36.2465 28.6238 36.5503 28.3266 36.5503 27.9633C36.5503 27.6 36.2465 27.3027 35.8751 27.3027H27.0971C26.7257 27.3027 26.4219 27.6 26.4219 27.9633Z"
      fill="#0075E0"
    />
    <path
      d="M35.8751 31.2661H27.0971C26.7257 31.2661 26.4219 31.5634 26.4219 31.9267C26.4219 32.29 26.7257 32.5872 27.0971 32.5872H35.8751C36.2465 32.5872 36.5503 32.29 36.5503 31.9267C36.5503 31.5634 36.2465 31.2661 35.8751 31.2661Z"
      fill="#0075E0"
    />
    <path
      d="M35.8751 35.2294H27.0971C26.7257 35.2294 26.4219 35.6257 26.4219 36.1101C26.4219 36.5945 26.7257 36.9908 27.0971 36.9908H35.8751C36.2465 36.9908 36.5503 36.5945 36.5503 36.1101C36.5503 35.6257 36.2465 35.2294 35.8751 35.2294Z"
      fill="#0075E0"
    />
  </svg>
);

const KnowledgeBaseIcon = () => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M23.9361 12.5819C25.2834 12.5819 25.9631 14.273 25.0092 15.2614C24.0554 16.2477 22.4179 15.545 22.4179 14.1518C22.4179 13.2847 23.0975 12.5819 23.9361 12.5819ZM23.3141 23V18.3396C23.3141 18.3109 23.3042 18.2883 23.2843 18.2698C21.3329 16.4862 18.8449 15.4855 16.1922 15.4855H10.2366C10.1869 15.4855 10.1452 15.5286 10.1452 15.58V36.1321C10.1452 36.1834 10.1869 36.2266 10.2366 36.2266H16.1922C18.72 36.2266 21.1483 37.0506 23.1694 38.5341C23.1972 38.5547 23.2329 38.5567 23.2647 38.5403C23.2965 38.5239 23.3144 38.493 23.3144 38.4561V32.2484C23.3144 32.2134 23.2985 32.1847 23.2687 32.1662C23.2389 32.1477 23.2071 32.1477 23.1773 32.1662L20.6317 33.6847C20.2601 33.9066 19.8011 33.6251 19.8011 33.1894V22.0586C19.8011 21.6333 20.2522 21.3168 20.6655 21.5819L20.6675 21.584L23.1773 23.084C23.2071 23.1025 23.2389 23.1025 23.2687 23.084C23.2985 23.0655 23.3141 23.0349 23.3141 23ZM24.729 24.0089L29.9571 27.1302C30.3128 27.3439 30.3486 27.9028 29.9273 28.137L29.9253 28.1391L25.2951 30.9028V30.9049L24.7288 31.2418C24.699 31.2603 24.6831 31.2891 24.6831 31.324V38.4581C24.6831 38.4951 24.701 38.5259 24.7328 38.5423C24.7646 38.5588 24.7983 38.5567 24.8281 38.5362C26.8511 37.0526 29.2775 36.2286 31.8053 36.2286H37.7609C37.8106 36.2286 37.8523 36.1855 37.8523 36.1341L37.8543 15.5778C37.8543 15.5265 37.8125 15.4833 37.7629 15.4833H31.8073C29.1564 15.4833 26.6666 16.484 24.7152 18.2676C24.6953 18.2861 24.6854 18.3108 24.6854 18.3375V23.9244C24.6854 23.9614 24.7012 23.9904 24.729 24.0089ZM38.5382 37.6426C38.9158 37.6426 39.2239 37.3261 39.2239 36.9337V22.3915C39.2239 22.3401 39.2656 22.297 39.3153 22.297H41.4336C41.7436 22.297 42 22.56 42 22.8826V40.1575C42 40.4781 41.7456 40.7431 41.4336 40.7431L31.8056 40.7411C29.3454 40.7411 27.0701 41.9637 25.6195 43.963C25.6016 43.9877 25.5758 44 25.546 44H22.4499C22.4201 44 22.3943 43.9877 22.3764 43.963C20.9258 41.9637 18.6504 40.7411 16.1904 40.7411H6.56636C6.25636 40.7411 6 40.4781 6 40.1554V22.8806C6 22.56 6.25436 22.2949 6.56636 22.2949H8.68671C8.73639 22.2949 8.77813 22.3381 8.77813 22.3895V36.9332C8.77813 37.3236 9.08415 37.6421 9.46373 37.6421H16.1962C17.5892 37.6421 18.9186 37.9175 20.1348 38.4188C21.3867 38.9346 22.5274 39.6887 23.5011 40.6298L23.5031 40.6319C23.7952 40.9319 24.2105 40.9319 24.5026 40.6298L24.5046 40.6278C25.4784 39.6887 26.619 38.9325 27.8709 38.4188C29.0871 37.9195 30.4165 37.6421 31.8096 37.6421L38.5382 37.6426ZM21.5495 2.54207C21.2991 2.83386 20.8699 2.86057 20.5857 2.60372C20.3035 2.34481 20.2777 1.90099 20.5261 1.6092C22.2867 -0.445581 25.355 -0.550419 27.2387 1.39756C29.6551 3.89621 28.6874 8.13339 25.482 9.27751C24.9773 9.45834 24.6613 9.91654 24.6613 10.4713C24.6613 10.8618 24.3553 11.1803 23.9757 11.1803C23.5981 11.1803 23.2901 10.8638 23.2901 10.4713C23.2901 9.3186 23.9777 8.32203 25.0348 7.94392C27.2863 7.14051 27.9659 4.15281 26.2689 2.39797C24.9474 1.02534 22.7835 1.10372 21.5495 2.54207Z"
      fill="#F19100"
    />
  </svg>
);

const ExcelIcon = () => (
  <svg
    width="12"
    height="13"
    viewBox="0 0 12 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7 3.45312V0H0.75C0.334375 0 0 0.27168 0 0.609375V12.3906C0 12.7283 0.334375 13 0.75 13H11.25C11.6656 13 12 12.7283 12 12.3906V4.0625H7.75C7.3375 4.0625 7 3.78828 7 3.45312ZM8.87813 6.15723L7 8.53125L8.87813 10.9053C9.0375 11.1084 8.85938 11.375 8.5625 11.375H7.47188C7.33438 11.375 7.20625 11.3141 7.14062 11.215C6.52812 10.2959 6 9.4707 6 9.4707C5.8 9.84648 5.6875 9.97852 4.85625 11.2176C4.79062 11.3166 4.66562 11.3775 4.52812 11.3775H3.4375C3.14062 11.3775 2.9625 11.1109 3.12188 10.9078L5.00625 8.53379L3.12188 6.15977C2.95938 5.95664 3.14062 5.69004 3.4375 5.69004H4.525C4.6625 5.69004 4.79062 5.75098 4.85625 5.85C5.67187 7.08906 5.48125 6.70312 6 7.58926C6 7.58926 6.19063 7.29219 7.14375 5.85C7.20938 5.75098 7.3375 5.69004 7.475 5.69004H8.5625C8.85938 5.6875 9.0375 5.9541 8.87813 6.15723V6.15723ZM12 3.09512V3.25H8V0H8.19063C8.39063 0 8.58125 0.0634766 8.72188 0.177734L11.7812 2.66602C11.9219 2.78027 12 2.93516 12 3.09512Z"
      fill="#F44336"
    />
  </svg>
);

const FileIcon = () => (
  <svg
    width="16"
    height="15"
    viewBox="0 0 16 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14 0.03125H5C4.175 0.03125 3.5 0.664062 3.5 1.4375V9.875C3.5 10.6484 4.175 11.2812 5 11.2812H14C14.825 11.2812 15.5 10.6484 15.5 9.875V1.4375C15.5 0.664062 14.825 0.03125 14 0.03125ZM7.625 5.30469C7.625 5.88828 7.1225 6.35938 6.5 6.35938H5.75V7.76562H4.625V3.54688H6.5C7.1225 3.54688 7.625 4.01797 7.625 4.60156V5.30469ZM11.375 6.71094C11.375 7.29453 10.8725 7.76562 10.25 7.76562H8.375V3.54688H10.25C10.8725 3.54688 11.375 4.01797 11.375 4.60156V6.71094ZM14.375 4.60156H13.25V5.30469H14.375V6.35938H13.25V7.76562H12.125V3.54688H14.375V4.60156ZM5.75 5.30469H6.5V4.60156H5.75V5.30469ZM2 2.84375H0.5V12.6875C0.5 13.4609 1.175 14.0938 2 14.0938H12.5V12.6875H2V2.84375ZM9.5 6.71094H10.25V4.60156H9.5V6.71094Z"
      fill="#F44336"
    />
  </svg>
);

const VideoIcon = () => (
  <svg
    width="14"
    height="12"
    viewBox="0 0 14 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.8889 4.5V1C10.8889 0.45 10.5389 0 10.1111 0H0.777778C0.35 0 0 0.45 0 1V11C0 11.55 0.35 12 0.777778 12H10.1111C10.5389 12 10.8889 11.55 10.8889 11V7.5L14 11.5V0.5L10.8889 4.5ZM8.55556 7H6.22222V10H4.66667V7H2.33333V5H4.66667V2H6.22222V5H8.55556V7Z"
      fill="#E13939"
    />
  </svg>
);

const SteamCupIcon = ({
  height = '14',
  width = '14',
  color = normalText.dark,
}: {
  height?: string;
  width?: string;
  color?: string;
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 14 14"
    fill="none"
  >
    <path
      d="M10.0469 5.38184H10.5657C11.1087 5.39235 11.626 5.61548 12.0064 6.00328C12.3868 6.39107 12.5998 6.91259 12.5998 7.45578C12.5998 7.99897 12.3868 8.52049 12.0064 8.90829C11.626 9.29608 11.1087 9.51921 10.5657 9.52973H10.0469"
      stroke={color}
      strokeLinecap="round"
    />
    <path
      d="M1.75 5.38184H10.0466V10.0485C10.0466 10.5986 9.82801 11.1263 9.439 11.5153C9.04998 11.9043 8.52237 12.1228 7.97222 12.1228H3.82433C3.27419 12.1228 2.74657 11.9043 2.35756 11.5153C1.96855 11.1263 1.75 10.5986 1.75 10.0485V5.38184Z"
      stroke={color}
      strokeLinecap="round"
    />
    <path
      d="M3.82422 1.75V3.30556"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.89844 1.75V3.30556"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.97266 1.75V3.30556"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const ExcavatorIcon = ({
  height = '10',
  width = '10',
  color = info.main,
}: {
  height?: string;
  width?: string;
  color?: string;
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 10 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.70838 7.70703C7.93338 7.70703 8.12505 7.8987 8.12505 8.1237C8.12505 8.3487 7.93338 8.54036 7.70838 8.54036H2.70838C2.48338 8.54036 2.29172 8.3487 2.29172 8.1237C2.29172 7.8987 2.48338 7.70703 2.70838 7.70703H7.70838ZM7.70838 7.08203H2.70838C2.13755 7.08203 1.66672 7.55287 1.66672 8.1237C1.66672 8.69453 2.13755 9.16537 2.70838 9.16537H7.70838C7.98465 9.16537 8.2496 9.05562 8.44495 8.86027C8.64031 8.66492 8.75005 8.39997 8.75005 8.1237C8.75005 7.84743 8.64031 7.58248 8.44495 7.38713C8.2496 7.19178 7.98465 7.08203 7.70838 7.08203ZM8.75005 4.58203H7.50005V2.91536H5.41672L4.16672 4.58203V6.66536H9.16672L8.75005 4.58203ZM4.80838 4.58203L5.62505 3.54036H6.66672V4.58203H4.80838ZM4.06672 1.41953L1.98338 0.832031L0.833384 4.92786C0.691717 5.4612 1.00422 6.01537 1.54172 6.16536L2.02505 6.2987L3.39588 5.11953L1.77922 4.66953L2.56255 1.85703L3.72505 2.18203C3.95838 2.30286 4.46255 2.64036 4.77922 3.06953L5.20838 2.4987H5.39172C4.86672 1.8362 4.10422 1.44036 4.06672 1.41953Z"
      fill={color}
    />
  </svg>
);

export {
  NoDataSvg,
  PinIcon,
  ImportIcon,
  ExportIcon,
  PdfIcon,
  AiSearchIconButton,
  AiSearchIconSearchbar,
  AiSummaryIcon,
  GradientAutoAwesomeIcon,
  GradientEnterIcon,
  GradientVariconIcon,
  AiBetaTagSearchBarIcon,
  PolishNoteIcon,
  TagGeneratorIcon,
  FileNameGeneratorIcon,
  AiSparkleSummaryIcon,
  AISummaryIcon,
  TalkWithDocsFileManagerIcon,
  VariconSparkleIcon,
  WarningFilledIcon,
  EquipmentIcon,
  EmployeeIcon,
  UnVerifiedIcon,
  GuidedTourIcon,
  KnowledgeBaseIcon,
  ExcelIcon,
  FileIcon,
  VideoIcon,
  SteamCupIcon,
  ExcavatorIcon,
};

export { EmptyIcon } from './empty';
